$(function(){
   $('.b-dots-submenu').each(function(){
       let parentBlock = $(this).closest('.landing-block');
       if(parentBlock) {
           if(parentBlock.attr('data-hide-menu') === "[1]") {
               $(this).remove();
           }
       }
   })
});